import api from '../utils/api';

/**
 * Notification service for API calls
 * Handles communication with the backend notification endpoints
 * Based on backend NotificationServiceImpl
 */
class NotificationService {
  /**
   * Fetch unread notifications for the current user
   * @returns {Promise<Array>} Array of notification payloads
   */
  async getUnreadNotifications() {
    try {
      const response = await api.get('/notifications');
      // Handle ApiEnvelope response structure
      const data = response.data?.data || response.data;
      return Array.isArray(data) ? data : [];
    } catch (error) {
      throw error;
    }
  }

  /**
   * Mark a notification as read
   * @param {number} notificationId - ID of the notification to mark as read
   * @returns {Promise<void>}
   */
  async markNotificationAsRead(notificationId) {
    try {
      await api.post(`/notifications/${notificationId}/read`);
    } catch (error) {
      throw error;
    }
  }

  /**
   * Delete a video owned by the current user
   * @param {number} videoId - ID of the video to delete
   * @returns {Promise<boolean>} Success status
   */
  async deleteMyVideo(videoId) {
    try {
      await api.delete(`/me/videos/${videoId}`);
      return true;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Get notification statistics for the current user
   * @returns {Promise<Object>} Notification stats
   */
  async getNotificationStats() {
    try {
      const response = await api.get('/notifications/stats');
      const data = response.data?.data || response.data;
      return data || {};
    } catch (error) {
      return {};
    }
  }

  /**
   * Mark all notifications as read for the current user
   * @returns {Promise<void>}
   */
  async markAllAsRead() {
    try {
      await api.post('/notifications/read-all');
    } catch (error) {
      throw error;
    }
  }
}

// Export singleton instance
const notificationService = new NotificationService();
export default notificationService;
